const mapsSearchUrl = process.env.REACT_APP_GOOGLE_MAPS_SEARCH_URL;
if (!mapsSearchUrl) throw new Error('REACT_APP_GOOGLE_MAPS_SEARCH_URL is required');

const normalizePart = (value) => String(value ?? '').trim().replace(/\s+/g, ' ');

export const buildGoogleMapsUrl = ({ address, city, state, postcode, country } = {}) => {
  let query = normalizePart(address);
  if (!query || /^(n\/?a|unknown|not provided|-)$/i.test(query)) return null;

  // Addresses from autocomplete often already contain the locality/postcode.
  // Add missing components for Maps only; never rewrite the stored address.
  [city, state, postcode, country].forEach((value) => {
    const part = normalizePart(value);
    if (!part) return;
    const escaped = part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (!new RegExp(`(?:^|[\\s,])${escaped}(?=$|[\\s,])`, 'i').test(query)) {
      query += `, ${part}`;
    }
  });

  const url = new URL(mapsSearchUrl);
  url.search = new URLSearchParams({ api: '1', query }).toString();
  // Google Maps URLs are limited to 2,048 characters. Keep unusually long
  // data as readable text instead of truncating it into a wrong destination.
  return url.href.length <= 2048 ? url.href : null;
};